import { reactive } from 'vue'
import actions from '@/store/qotd/actions'
import state from '@/store/qotd/state'
import getters from '@/store/qotd/getters'

export const qotdModule = {
    state: reactive(state),
    actions,
    getters,
}
